/**
 * Class description
 *
 * Created: 2018-05-18
 * @author jonas
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DirtyWildsLayerConfig} from "../../../config/DirtyWildsLayerConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {TimelineLite} from "gsap";
import {SpinsLeftMeterView} from "./SpinsLeftMeterView";
import {MultiplierMeterView} from "./MultiplierMeterView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {DirtyWildsGameAssets} from "../../DirtyWildsGameAssets";
import {DirtyWildsSoundConfig} from "../../DirtyWildsSoundConfig";
import {DirtyWilds} from "../../DirtyWilds";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {DirtyWildGameModuleConfig} from "../../DirtyWildGameModuleConfig";


export class DirtyWildsTopBarView extends BaseView {

    private _layer:ScalableLayer;

    private _spinsMeter:SpinsLeftMeterView;
    private _multiplierMeter:MultiplierMeterView;
    private _trailContainer:PIXI.Container;
    private _fireTrailLayer:ScalableLayer;


    constructor() {
        super();
        this._layer = StageManager.getLayer(DirtyWildsLayerConfig.TOP_BAR_LAYER.name);
        this._fireTrailLayer = StageManager.getLayer(DirtyWildsLayerConfig.FIRE_TRAIL_LAYER.name);
        this._layer.addChild(this);
    }


    protected initAnimations():void {
        this._trailContainer = new PIXI.Container();
        this._trailContainer.position.set(360, 340);

        this._spinsMeter = new SpinsLeftMeterView(0);
        this._spinsMeter.position.set(360, 240);

        this._multiplierMeter = new MultiplierMeterView(1);
        this._multiplierMeter.position.set(360, 240);

        this.addChild(this._spinsMeter);
        this.addChild(this._multiplierMeter);
        this._fireTrailLayer.addChild(this._trailContainer);

    }

    // public highlightLogo():TimelineLite{
    //     return this._multiplierMeter.highlightLogo();
    // }


    public addMultiplier(index:number, multiplier:number, position:[number, number], isDouble:boolean = false):TimelineLite {
        return this._multiplierMeter.getUpdateTickAnimation(index, multiplier, isDouble);
    }

    public updateMeterIndexOnWOW(index:number):TimelineLite{
        return this._multiplierMeter.updateMeterIndexOnWOW(index);
    }

    public addSpins(value:number, position:[number, number]):TimelineLite {
        return this._spinsMeter.getUpdateTickAnimation(value);
    }

    public removeSpins(value:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(this._spinsMeter.getUpdateTickAnimation(value));
        return tl;
    }

    public setTopBar(multiplierIndex:number, multiplier:number, spins:number, isRestore:boolean = false) {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this._multiplierMeter.getUpdateTickAnimation(multiplierIndex, multiplier, isRestore),
            this._spinsMeter.getUpdateTickAnimation(spins)
        ]);
        return tl;
    }

}